import React from 'react';
import { Clock, ChevronUp, ChevronDown } from 'lucide-react';
import { AIResponse } from '../types/ai';

interface ConversationEntry {
  question: string;
  response: AIResponse;
  timestamp: number;
}

interface PreviousQuestionsDropdownProps {
  history: ConversationEntry[];
  showHistory: boolean;
  setShowHistory: (show: boolean) => void;
  onSelectQuestion: (question: string) => void;
}

export function PreviousQuestionsDropdown({
  history,
  showHistory,
  setShowHistory,
  onSelectQuestion
}: PreviousQuestionsDropdownProps) {
  if (history.length === 0) return null;

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setShowHistory(!showHistory)}
        className="w-full flex items-center justify-between px-4 py-2 bg-white/5 border border-white/10 rounded-lg text-white/80 hover:text-white hover:border-white/20 transition-colors"
      >
        <span className="flex items-center gap-2">
          <Clock size={16} />
          Previous Questions
        </span>
        {showHistory ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </button>

      {showHistory && (
        <div className="absolute z-10 mt-1 w-full bg-obsidian-800 border border-white/10 rounded-lg shadow-lg max-h-96 overflow-y-auto">
          <div className="p-2 border-b border-white/10">
            <div className="flex items-center justify-between text-sm text-white/60 px-2 py-1">
              <span className="flex items-center gap-1">
                <Clock size={14} />
                Previous Questions
              </span>
              <span className="text-xs">{history.length} items</span>
            </div>
          </div>
          <div className="py-1">
            {history.map((entry, index) => (
              <button
                key={index}
                type="button"
                onClick={() => {
                  onSelectQuestion(entry.question);
                  setShowHistory(false);
                }}
                className="w-full text-left px-4 py-2 text-sm text-white/80 hover:bg-white/5 flex items-center justify-between group"
              >
                <span className="truncate flex-1">{entry.question}</span>
                <span className="text-xs text-white/40 group-hover:text-white/60">
                  {new Date(entry.timestamp).toLocaleDateString()}
                </span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
